import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {activeItemPopularProducts} from "../../ducks/content";
import ProductCards from "../../../common/ProductCards";

function PopularProducts({popularProducts}) {
  return (
    <ProductCards
      title="Популярные товары этой категории"
      products={popularProducts}
    />
  );
}

PopularProducts.propTypes = {
  popularProducts: PropTypes.array
};

export default connect((state) => ({
  popularProducts: activeItemPopularProducts(state)
}))(PopularProducts);
